import { useQuery } from '@tanstack/react-query';

const apiUrl = process.env.REACT_APP_BACKEND_API;

export const useWaterBalances = (dmaId) => {
  const {
    data: waterBalance,
    isLoading: isLoadingWaterBalance,
    error,
    refetch,
  } = useQuery({
    queryKey: ['waterBalances', dmaId ?? 'all'],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const url = dmaId
        ? `${apiUrl}/waterBalances/${dmaId}`
        : `${apiUrl}/waterBalances`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`WaterBalance fetch failed: ${response.status} ${text}`);
      }

      return response.json();
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return { waterBalance, isLoadingWaterBalance, error, refetch };
};
